import React from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import styles from "./FreeShippingPromoBanner.module.scss";

type Props = {
  className?: string;
};

const FreeShippingPromoBanner = ({ className }: Props) => {
  const { t } = useTranslation("helpCenterUrls");

  return (
    <div className={classnames(styles.banner, className)}>
      <p className={styles.summary}>
        <span className={styles.headline}>
          Free shipping on your first purchase.
        </span>
        <a
          className={styles.termsLink}
          href={t("freeShippingForNewBuyers")}
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms
        </a>
      </p>
    </div>
  );
};

export default FreeShippingPromoBanner;
